import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledEmptyStateDiv = styled.div`
  ${center()}
  padding: 30px 50px 50px 50px;
`;

const IconWrapperDiv = styled.div`
  width: 70px;
  height: 70px;
  ${center()}
  border-radius: 50%;
  background-color: ${(p) => p.theme.greys.shade30};
  opacity: 0.5;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.large};
  color: ${(p) => p.theme.greys.shade90};
  margin: 16px 0 8px 0;
`;

const StyledBodyDiv = styled.div`
  color: ${(p) => p.theme.greys.shade80};
`;

/*
 * Props.
 */

interface SettingsBusinessHoursEmptyStateProps {
  hasBusinessHours: boolean;
}

/*
 * Component.
 */

export const SettingsBusinessHoursEmptyState: FC<SettingsBusinessHoursEmptyStateProps> = ({
  hasBusinessHours,
}) => {
  const theme = useUserTheme();

  if (hasBusinessHours) {
    return null;
  }
  return (
    <StyledEmptyStateDiv>
      <IconWrapperDiv>
        <Icon name="snooze" size={40} color={theme.greys.shade60} />
      </IconWrapperDiv>
      <StyledTitleDiv>
        <Trans id="business-hours-empty-state-title">No business hours</Trans>
      </StyledTitleDiv>
      <StyledBodyDiv>
        <Trans id="business-hours-empty-state-body">Select days to set business hours</Trans>
      </StyledBodyDiv>
    </StyledEmptyStateDiv>
  );
};
